import { Link } from "react-router-dom";
import ImageSlider from "./ImageSlider";

export default function HomePromoCards() {
  return (
    <aside className="home-promo-stack home-promo-panel" aria-label="Kemudahan tambahan Etikaf">
      <Link
        className="home-promo-card home-promo-card-app"
        to="/my"
        aria-label="Kenali Etikaf untuk Masjid"
      >
        <ImageSlider />
      </Link>
    </aside>
  );
}
